import { Component, OnInit, Inject, Input, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { PdfJsViewerComponent } from 'ng2-pdfjs-viewer';

const API_URL = environment.apiUrl;

@Component({
  selector: 'app-resource-viewer',
  standalone: false,
  templateUrl: './glm-resource-viewer.component.html',
  styleUrls: ['./glm-resource-viewer.component.scss']
})
export class GlmResourceViewerComponent implements OnInit {

  @Input()
  unsafeUrl$: Observable<string>;

  @Input()
  store: string;

  @Input()
  origen: string;

  isSafari: boolean;

  url$: Observable<any>;

  visible = false;

  @ViewChild('pdfViewer') public pdfViewer: PdfJsViewerComponent;

  constructor(private sanitizer: DomSanitizer, private http: HttpClient) {
  }
  ngOnInit(): void {
    this.unsafeUrl$.subscribe((unsafeUrl) => {
      this.visible = true;
      if (unsafeUrl) {
        if (!this.esImagen(unsafeUrl)) {
          this.downloadFile(unsafeUrl).subscribe(
            (res) => {
                    this.pdfViewer.pdfSrc = res; // pdfSrc can be Blob or Uint8Arra   y
                    this.pdfViewer.refresh(); // Ask pdf viewer to load/refresh pd
                }
            );
        }
      } else {
        if (this.pdfViewer) {
          this.visible = false;
        }
      }
    });
    // this.isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  }

  url(unsafeUrl) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(unsafeUrl);
  }

  esImagen(unsafeUrl): boolean {
    const match = unsafeUrl.match('\.pdf');
    if (match === null) {
        return true;
    } else {
        return false;
    }
  }

  private downloadFile(url: string): any {
    const model = {url: url};
      return this.http.post(`${API_URL}/api/Storage/download`, model, { responseType: 'blob',
        headers: new HttpHeaders().set('Origen', this.origen).set('Store', this.store)})
          .pipe(
              map((result: any) => {
                  return result;
              })
          );
  }
}
